import { render, staticRenderFns } from "./SelectMultipleRoles.vue?vue&type=template&id=269079d7&"
import script from "./SelectMultipleRoles.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports